document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggles = document.querySelectorAll('.mobile-menu-items #primary-menu li.menu-item a.dropdown-toggle');
  
    dropdownToggles.forEach(function (toggle, index) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
  
        // Close other open dropdowns
        const openDropdowns = document.querySelectorAll('.dropdown-menu.show');
        openDropdowns.forEach(function (dropdown, i) {
          dropdown.classList.remove('show');
          dropdown.style.transitionDelay = `-${(openDropdowns.length - i - 1) * 100}ms`;
        });
  
        // Toggle the current dropdown
        const dropdownMenu = toggle.nextElementSibling;
        dropdownMenu.style.transitionDelay = `${(dropdownToggles.length - index - 1) * 100}ms`;
        dropdownMenu.classList.toggle('show');
      });
    });
  
    // Close dropdowns when clicking outside
    document.addEventListener('click', function (event) {
      const dropdownMenus = document.querySelectorAll('.dropdown-menu');
      dropdownMenus.forEach(function (menu, index) {
        if (!menu.classList.contains('show')) return;
  
        if (!menu.parentElement.contains(event.target) && !event.target.classList.contains('dropdown-toggle')) {
          menu.classList.remove('show');
          menu.style.transitionDelay = `-${(dropdownMenus.length - index - 1) * 100}ms`;
        }
      });
    });
  });
  